var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 75,
    viewBox: "0 0 242 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53884_3849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0309 41.7616C35.9115 44.5178 34.8312 47.2008 33.7379 49.8773C31.6057 55.0924 29.4908 60.3161 27.3064 65.5096C27.0028 66.2156 26.5077 66.8243 25.8762 67.2681C22.4767 69.5373 19.0208 71.7267 15.5779 73.9313C15.1789 74.1471 14.7674 74.3393 14.3455 74.5067L6.66195 57.9132L30.0625 42.4426L30.0277 42.1495L0 36.15L8.44209 0.105595L8.74422 0L37.0309 41.7616ZM8.5725 29.2174L32.4316 41.1819L32.6142 42.4318L8.44426 58.411L14.8236 72.2159L35.3855 41.8521L9.75927 4.02121L9.4767 4.16991C9.17675 12.4472 8.87897 20.7246 8.5725 29.2174ZM2.6713 34.9949L2.75607 35.2815L26.1131 39.9169L26.1913 39.626L7.96174 30.4974L2.6713 34.9949ZM32.5447 49.0024L32.3077 48.9162L17.7058 70.4919C17.9949 70.6083 18.1166 70.6062 18.2035 70.5501C20.551 69.0416 22.9071 67.559 25.2263 66.0246C25.5883 65.7333 25.8633 65.3496 26.0218 64.9148C26.9217 62.7922 27.778 60.6522 28.6518 58.5188L32.5447 49.0024ZM7.17273 29.3079L7.8248 10.1996L7.54876 10.1716C5.74761 17.8433 3.94645 25.5151 2.1453 33.1869L2.42786 33.3377L7.17273 29.3079Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6681 74.6468C61.8813 74.1619 61.2488 73.7848 60.6293 73.3882C57.4625 71.3561 54.2869 69.3369 51.1505 67.2594C50.5959 66.9045 50.1525 66.4029 49.8702 65.8113C46.6338 58.0059 43.4474 50.1811 40.2501 42.3607C40.1914 42.2184 40.161 42.0633 40.0566 41.7142C49.4232 27.8863 58.8325 13.9909 68.2846 0.0280151L68.5954 0.058185C71.4037 12.0378 74.2097 24.0174 77.0549 36.1478L47.0598 42.1344L46.9533 42.4038L70.3864 57.9003L62.6681 74.6468ZM68.6085 58.4111L44.4124 42.4124C44.5059 41.9318 44.5776 41.5504 44.6537 41.1647L68.515 29.198C68.1933 20.7418 67.876 12.4278 67.5586 4.11172L67.2782 4.03846L41.6694 41.8543L62.2226 72.2267L68.6085 58.4111ZM69.0779 30.4931L50.831 39.6519L50.9375 39.9255L74.3358 35.2643L74.364 34.9841L69.0779 30.4931ZM59.16 70.6708L59.2948 70.5437C59.1339 70.257 58.9948 69.9575 58.8122 69.6817C57.7429 68.0977 56.6604 66.5224 55.5889 64.9407C52.1474 59.852 48.7009 54.7598 45.2493 49.6639C45.071 49.401 44.8602 49.1597 44.6646 48.9097C46.7295 54.4373 48.9378 59.8614 51.1852 65.2704C51.3483 65.6626 51.7721 65.9945 52.1503 66.2445C54.2108 67.6064 56.2931 68.9339 58.371 70.2657C58.6266 70.4145 58.89 70.5497 59.16 70.6708ZM74.6075 33.314L74.9205 33.1502L69.5148 10.1608L69.2236 10.206C69.4409 16.5848 69.6583 22.9636 69.8626 29.3014L74.6075 33.314Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4411 21.7654H50.1191L39.3991 37.624H37.6603L26.9512 21.787L28.5813 21.7008C31.8764 26.5581 35.1476 31.3745 38.534 36.3547L48.4411 21.7654Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5716 29.2174C8.87807 20.7245 9.17585 12.4472 9.4758 4.1699L9.75836 4.02121L35.3846 41.8521L14.8227 72.2159L8.44336 58.411L32.6133 42.4318L32.4307 41.1819L8.5716 29.2174Z",
    fill: "url(#paint0_linear_53884_3849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67188 34.9949L7.96231 30.4974L26.1919 39.626L26.1137 39.9169L2.75664 35.2815L2.67188 34.9949Z",
    fill: "url(#paint1_linear_53884_3849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5439 49.0045L28.6511 58.5102C27.7817 60.6436 26.9123 62.7835 26.0211 64.9062C25.8626 65.3409 25.5876 65.7246 25.2256 66.016C22.9064 67.559 20.5503 69.0481 18.2028 70.5415C18.1159 70.5975 17.9855 70.5997 17.7051 70.4833L32.307 48.9183L32.5439 49.0045Z",
    fill: "url(#paint2_linear_53884_3849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17197 29.3079L2.42709 33.3269L2.14453 33.1761C3.94713 25.5115 5.74974 17.8455 7.55234 10.178L7.82838 10.206L7.17197 29.3079Z",
    fill: "url(#paint3_linear_53884_3849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.609 58.411L62.2231 72.2267L41.6699 41.8542L67.2787 4.03845L67.5591 4.11172C67.8765 12.4278 68.1938 20.7418 68.5155 29.198L44.6542 41.1603C44.5781 41.5547 44.5064 41.9275 44.4129 42.4081L68.609 58.411Z",
    fill: "url(#paint4_linear_53884_3849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0771 30.4931L74.3719 34.9841L74.3436 35.2643L50.9366 39.9234L50.8301 39.6497L69.0771 30.4931Z",
    fill: "url(#paint5_linear_53884_3849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1599 70.6708C58.8913 70.5496 58.6294 70.4143 58.3753 70.2657C56.2952 68.9339 54.2151 67.6064 52.1654 66.2445C51.7872 65.9945 51.3634 65.6626 51.2004 65.2704C48.9485 59.8614 46.7402 54.4373 44.6797 48.9097C44.8753 49.1597 45.0861 49.401 45.2644 49.6639C48.7058 54.7555 52.1473 59.8492 55.5888 64.945C56.6603 66.5268 57.7428 68.1021 58.8121 69.686C58.9947 69.9575 59.1338 70.257 59.2947 70.548L59.1599 70.6708Z",
    fill: "url(#paint6_linear_53884_3849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6065 33.314L69.8617 29.3079C69.6443 22.97 69.427 16.5934 69.2227 10.2125L69.5139 10.1672L74.9195 33.1567L74.6065 33.314Z",
    fill: "url(#paint7_linear_53884_3849)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_53884_3849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.001 52.6465L95.1152 31.6882H98.9341C99.2002 32.6962 99.6484 34.4016 100.279 36.8042C100.909 39.2068 101.452 41.296 101.907 43.0717C102.359 44.8527 102.788 46.575 103.194 48.2384C103.639 46.5429 104.125 44.8037 104.652 43.0209C105.179 41.2381 105.817 39.1578 106.566 36.7802C107.318 34.3953 107.843 32.6989 108.142 31.6908H111.557L115.234 43.4056L116.652 48.3132C117.037 46.6355 117.449 44.899 117.889 43.1037C118.328 41.3084 118.847 39.222 119.444 36.8443C120.034 34.4648 120.46 32.7461 120.723 31.6882H124.431L118.685 52.6465H114.569L109.758 36.7428L105.062 52.6465H101.001Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.211 52.6465L133.489 31.6882H137.138L145.484 52.6438H141.427L139.43 47.5332H131.113L129.158 52.6438L125.211 52.6465ZM132.455 44.1269H137.97C136.89 40.8552 135.981 38.1337 135.244 35.9627C134.629 37.7775 133.7 40.499 132.455 44.1269Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.062 52.6465V50.6883L158.812 34.8299H149.43V31.6882H163.778V33.5876L153.974 49.5074H163.763V52.6465H149.062Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.527 52.9751C174.313 52.9751 171.778 51.9902 169.924 50.0204C168.07 48.0505 167.143 45.3995 167.143 42.0671C167.143 38.8274 168.074 36.2227 169.937 34.2529C171.8 32.283 174.344 31.3035 177.57 31.3141C180.691 31.3141 183.175 32.2937 185.021 34.2529C186.866 36.212 187.788 38.8185 187.786 42.0725C187.786 45.4119 186.876 48.0648 185.055 50.031C183.234 51.9973 180.725 52.9787 177.527 52.9751ZM177.443 49.8547C179.545 49.8547 181.143 49.1806 182.239 47.8324C183.335 46.4841 183.885 44.5624 183.889 42.0671C183.889 39.6503 183.342 37.7722 182.247 36.4328C181.153 35.0935 179.577 34.4247 177.52 34.4265C175.434 34.4265 173.833 35.0953 172.716 36.4328C171.599 37.7704 171.033 39.6485 171.019 42.0671C171.019 44.5731 171.562 46.4966 172.648 47.8377C173.733 49.1788 175.332 49.8512 177.443 49.8547Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.359 52.6465V31.6882H199.059C199.654 31.6882 200.187 31.7006 200.658 31.7256C201.131 31.7496 201.669 31.803 202.279 31.8832C202.822 31.9501 203.359 32.0636 203.883 32.2225C204.371 32.3828 204.841 32.5931 205.286 32.8503C205.73 33.1008 206.125 33.4312 206.452 33.8254C206.782 34.2364 207.036 34.7042 207.203 35.2066C207.404 35.8086 207.501 36.4411 207.492 37.0767C207.492 39.148 206.582 40.6397 204.761 41.5515C205.878 41.8082 206.864 42.4761 207.526 43.427C208.154 44.4085 208.475 45.5609 208.446 46.7317C208.451 47.5027 208.292 48.2658 207.978 48.9678C207.652 49.6804 207.186 50.317 206.607 50.8379C205.914 51.4455 205.101 51.8946 204.222 52.1549C203.138 52.4911 202.009 52.6542 200.876 52.6385L193.359 52.6465ZM196.952 40.3841H200.023C200.469 40.3877 200.915 40.342 201.352 40.2478C201.756 40.1568 202.145 40.0037 202.505 39.7937C202.867 39.5847 203.164 39.2753 203.361 38.9014C203.579 38.4755 203.686 38.0001 203.673 37.5202C203.673 36.4836 203.323 35.7756 202.623 35.3963C201.922 35.0169 200.809 34.8281 199.282 34.8299H196.963L196.952 40.3841ZM196.994 49.5235H200.235C203.13 49.5235 204.577 48.5394 204.577 46.5714C204.577 45.346 204.254 44.5018 203.608 44.0388C202.962 43.5757 201.809 43.3459 200.149 43.3495H196.997L196.994 49.5235Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.875 52.6465V31.6882H217.468V52.6438L213.875 52.6465Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.725 52.6465L230.003 31.6882H233.651L242.001 52.6438H237.938L235.944 47.5332H227.624L225.672 52.6438L221.725 52.6465ZM228.968 44.1269H234.484C233.398 40.8552 232.488 38.1346 231.752 35.9653C231.141 37.7784 230.213 40.499 228.968 44.1269Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.122 26.2783H184.97L184.345 27.7663H182.473L185.787 20.5531H187.261L190.586 27.7663H188.747L188.122 26.2783ZM187.515 24.8517L186.549 22.5728L185.585 24.8517H187.515Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.292 27.3977C191.754 27.1002 191.315 26.6476 191.029 26.0966C190.723 25.4964 190.57 24.8276 190.585 24.1517C190.572 23.4811 190.724 22.8179 191.029 22.2229C191.316 21.6746 191.755 21.2241 192.292 20.9272C192.885 20.61 193.548 20.4519 194.217 20.4677C194.675 20.4671 195.131 20.5392 195.567 20.6814C195.954 20.7963 196.312 20.9929 196.618 21.2584L196.051 22.5942C195.537 22.1905 194.908 21.9665 194.259 21.9557C194.014 21.9406 193.768 21.9823 193.541 22.0776C193.313 22.1729 193.11 22.3194 192.946 22.5061C192.641 22.8747 192.489 23.4197 192.489 24.141C192.489 24.8624 192.641 25.4189 192.943 25.8108C193.106 25.9992 193.309 26.1472 193.537 26.2436C193.764 26.3399 194.011 26.3819 194.257 26.3665C194.905 26.3555 195.533 26.1326 196.048 25.7306L196.615 27.0664C196.309 27.3319 195.951 27.5286 195.565 27.6435C195.128 27.7847 194.673 27.8559 194.215 27.8545C193.546 27.8707 192.884 27.7135 192.292 27.3977Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.64 26.2783H199.489L198.858 27.7663H196.988L200.303 20.5531H201.776L205.099 27.7663H203.26L202.64 26.2783ZM202.034 24.8517L201.07 22.5728L200.103 24.8517H202.034Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.762 20.5585H208.651C209.351 20.5444 210.045 20.6962 210.678 21.002C211.231 21.2687 211.689 21.7014 211.992 22.2416C212.306 22.8312 212.463 23.4945 212.446 24.1651C212.46 24.8362 212.304 25.4997 211.992 26.0913C211.695 26.6322 211.242 27.067 210.694 27.3362C210.058 27.6388 209.361 27.7861 208.659 27.7663H205.77L205.762 20.5585ZM208.527 26.2489C209.217 26.2489 209.734 26.0752 210.077 25.7279C210.42 25.3806 210.595 24.8552 210.602 24.1517C210.602 22.7679 209.915 22.0759 208.54 22.0759H207.632V26.2489H208.527Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.611 20.5585H218.667V22.0171H215.431V23.3716H218.457V24.8303H215.431V26.3103H218.667V27.7663H213.611V20.5585Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.058 20.5585V27.7717H225.427V24.4723L224.072 27.7663H222.89L221.535 24.507V27.7663H219.914V20.5585H221.377L223.497 25.4795L225.598 20.5585H227.058Z",
    fill: "#38004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.375 25.0093V27.7663H230.491V25.0093L227.516 20.5585H229.617L231.426 23.4331L233.239 20.5585H235.366L232.375 25.0093Z",
    fill: "#38004D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53884_3849",
    x1: 8.44336,
    y1: 38.1175,
    x2: 35.3846,
    y2: 38.1175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40DDCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53884_3849",
    x1: 2.67188,
    y1: 35.2061,
    x2: 26.1919,
    y2: 35.2061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_53884_3849",
    x1: 17.7051,
    y1: 59.7536,
    x2: 32.5439,
    y2: 59.7536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_53884_3849",
    x1: 2.14453,
    y1: 21.7525,
    x2: 7.82838,
    y2: 21.7525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_53884_3849",
    x1: 41.6699,
    y1: 38.1326,
    x2: 68.609,
    y2: 38.1326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40DDCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_53884_3849",
    x1: 50.8301,
    y1: 35.2083,
    x2: 74.3719,
    y2: 35.2083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_53884_3849",
    x1: 44.6645,
    y1: 59.7903,
    x2: 59.2947,
    y2: 59.7903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_53884_3849",
    x1: 69.2227,
    y1: 21.7374,
    x2: 74.9195,
    y2: 21.7374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8876E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53884_3849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.0547,
    height: 74.6468,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_53884_3849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146.886,
    height: 32.5075,
    fill: "white",
    transform: "translate(95.1152 20.4677)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.de541c49ee4d505fec710af04b553633.svg";
export { ForwardRef as ReactComponent };